import { useEffect, useState, useRef } from 'react';
import { getApiBaseUrl } from '../../api/apiConfig';
import './Gallery.css';

const ImageViewer = ({ image, onClose }) => {
  const [loading, setLoading] = useState(true);
  const [imageLoaded, setImageLoaded] = useState(false);
  const imgRef = useRef(null);

  const API_BASE = getApiBaseUrl();
  const imagePath = (image.image_url || image.image_path)?.trim();
  let fullImageUrl = null;
  if (imagePath) {
    if (imagePath.startsWith('http')) {
      fullImageUrl = imagePath;
    } else {
      const normalizedPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
      fullImageUrl = `${API_BASE}${normalizedPath}`;
    }
  }

  // Close on Escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  // Prevent body scroll
  useEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, []);

  return (
    <div className="image-viewer-overlay" onClick={onClose} style={{ pointerEvents: 'auto' }}>
      <div className="image-viewer-content" onClick={(e) => e.stopPropagation()}>
        <button className="image-viewer-close" onClick={onClose} title="Close (ESC)">
          ×
        </button>
        
        <div className="image-viewer-image-container">
          {loading && (
            <div className="image-viewer-loader">
              <div className="spinner"></div>
              <p>Loading high-resolution image...</p>
            </div>
          )}
          
          {fullImageUrl && (
            <img 
              ref={imgRef}
              src={fullImageUrl} 
              alt={image.title || 'Gallery image'} 
              className={`image-viewer-image ${imageLoaded ? 'fade-in' : 'hidden'}`}
              onLoad={() => {
                setLoading(false);
                setImageLoaded(true);
              }}
              onError={() => setLoading(false)}
            />
          )}
        </div>

        {imageLoaded && (
          <div className="image-viewer-footer fade-in">
            <h3>{image.title || image.caption || 'Untitled'}</h3>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageViewer;
